import {
  faPlus, faPlusCircle, faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDebounceValue } from 'usehooks-ts'
import CustomButton from "../components/CustomButton";
import PageLayout from "../components/PageLayout";
import SearchIcon from "../../src/assests/SearchIcon.svg";
import axiosInstance from "../utils/axiosInstance";
import CreateAgentModel from "../components/agentComponents/CreateAgentModel";
import Table from "../components/Table";
import UserRow from "../components/agentComponents/AgentRow";
import { User } from "../providers/AuthProvider";
import { agentHeading } from "../components/agentComponents/agentTableData";
import DeleteAgentModel from "../components/agentComponents/DeleteAgentModel";
import GetUser from "../utils/getUser";
import { useNavigate } from "react-router-dom";
import PaginationMenu from "../components/pagination/paginationMenu";
import ChatIcon from "../components/chat-components/chat-icon";


const Agent = () => {
  const user = GetUser()
  const [search, setSearch] = useDebounceValue<string>("", 1000)
  const [model, setModel] = useState<User | boolean>(false)
  const [isDelete, setIsDelete] = useState<number | null>(null)
  const [users, setUsers] = useState<User[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [pageSize] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  // ---------------------------- [ USER DATA ] ----------------------------------------
  useEffect(() => {
    const FindUsers = async () => {
      setLoading(true)
      try {
        const res = await axiosInstance.get(search ? `/user?search=${search}&page=${page}&limit=${pageSize}` : `/user?page=${page}&limit=${pageSize}`)
        setTotalCount(res.data.totalCount)
        setUsers(res.data?.data)
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }

    FindUsers()
  }, [model, isDelete, search, page, pageSize])


  // ---------------------------------- [ OPEN AND CLOSE MODEL ] -----------------------------
  const ToggleModel = () => {
    setModel((prev) => typeof (prev) === 'boolean' ? !prev : false)
  }

  const ToggleDeleteModel = (id?: number) => {
    setIsDelete(id ? id : null)
  }

  // --------------------------------------- [ CALL TO ACTIONS ] -----------------------------
  const tableAction = [
    {
      name: "Edit Agent",
      icon: faPlusCircle,
      actionHandler: (data: User) => setModel(data),
    },
    {
      name: "Delete Agent",
      icon: faTrashCan,
      actionHandler: (data: User) => ToggleDeleteModel(data?.id),
    },
  ];

  // -------------------------------- [ UPDATE CURRENT PAGE ] --------------------------

  const OnChangeCurrentPage = (page) => {
    setPage(page)
  }


  useEffect(() => {
    if (user?.type && user?.type === "agent") {
      navigate("/")
    }
  }, [user?.type, navigate])


  return (
    <PageLayout
      pageTitle="Agents"
      primaryAction={
        <>
          <ChatIcon />
          <CustomButton
            className="!rounded-full !font-dmSans !text-[16px] !font-bold ml-4 smallTablet:!text-[14px] smallTablet:ml-2"
            variant="primary"
            renderLeftIcon={
              <FontAwesomeIcon
                icon={faPlus}
                className="bg-white/15 text-white text-[16px] rounded-full outline-none p-1"
              />
            }
            onClick={ToggleModel}
          >
            Add Agent
          </CustomButton>
        </>
      }
    >
      {isDelete && <DeleteAgentModel ToggleDeleteModel={ToggleDeleteModel} id={isDelete} />}
      {model && <CreateAgentModel ToggleModel={ToggleModel} isEdit={model} />}
      <div className="bg-surface px-8 border mt-8 border-edge rounded-2xl shadow-card py-6 animate-fade-in smallTablet:px-4 smallTablet:py-4 smallTablet:mt-4 smallTablet:min-w-0">
        <div className="mb-4 flex justify-between items-center smallTablet:flex-col smallTablet:items-start smallTablet:gap-3">
          <div>
            <h1 className="font-bold leading-[31px] text-[22px] smallTablet:text-[18px] bg-gradient-heading bg-clip-text text-transparent">
              Agent List
            </h1>
            <p className="text-light-gray font-medium text-[16px]">
              All agents
            </p>
          </div>
          <div className="ml-auto smallTablet:ml-0 smallTablet:w-full rounded-3xl flex bg-input-bg text-light-gray items-center border border-input-border focus-within:border-indigo-400/40 transition-all duration-200 py-2 px-4">
            <div className="ml-1 mr-3 flex items-center text-label-muted">
              <img src={SearchIcon} className="w-3 h-3" alt="" />
            </div>
            <input
              type="text"
              placeholder="Search..."
              className="flex-grow font-dmSans text-sm text-text-primary placeholder:text-label-muted bg-inherit focus:outline-none smallTablet:min-w-0"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-3 smallTablet:min-w-0">
          <Table headingData={agentHeading} tableData={users} tableAction={user?.type === "super-admin" ? tableAction : undefined} renderRow={UserRow} isLoading={loading && (!model && !isDelete)} totalCount={totalCount} />
          <PaginationMenu totalCount={totalCount} currentPage={page} pageSize={pageSize} onPageChange={OnChangeCurrentPage} />

        </div>
      </div>
    </PageLayout>
  );
};

export default Agent;
